<template>
  <the-confirmation-modal
    :title="trans.get('miliboo.product.my_cart', { count })"
    :cancel-text="trans.get('miliboo.product.continue_shopping')"
    :confirm-text="`${trans.get('miliboo.product.order')} - ${amount}`"
    @confirm="goToCart"
  >
    <v-cart-summary
      v-if="cart"
      :cart="cart"
    />
    <template #icon>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3 6L6 2H18L21 6M3 6V20C3 20.5304 3.21071 21.0391 3.58579 21.4142C3.96086 21.7893 4.46957 22 5 22H19C19.5304 22 20.0391 21.7893 20.4142 21.4142C20.7893 21.0391 21 20.5304 21 20V6M3 6H21M16 10C16 11.0609 15.5786 12.0783 14.8284 12.8284C14.0783 13.5786 13.0609 14 12 14C10.9391 14 9.92172 13.5786 9.17157 12.8284C8.42143 12.0783 8 11.0609 8 10"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </template>
  </the-confirmation-modal>
</template>
<script setup>
import { inject, ref, watch } from 'vue';
import TheConfirmationModal from '../common/TheConfirmationModal.vue';
import VCartSummary from '../../features/cart/components/VCartSummary.vue';
import useCartQuery from '../../features/cart/api/useCartQuery';

const trans = inject('translate');

const { route } = inject('jsRoutes');
const modal = inject('modal');

const count = ref(0);
const amount = ref(0);
const cart = ref(null);

const { data } = useCartQuery();

watch(data, () => {
  cart.value = data?.value?.data?.cart;
  count.value = data?.value?.data?.items_count;
  amount.value = cart.value?.amounts?.productsAmountDisplayable;
});

watch(count, () => {
  if (!count.value) {
    modal.value.open = false;
  }
});

const goToCart = function () {
  window.location.href = route('shop.cart-show');
};
</script>
